export default "__VITE_ASSET__I_p8QamU__"